import { Pipe, PipeTransform } from '@angular/core';
import { I18nService } from 'src/app/core/services/i18n.service';

// "Employee + Spouse" → api_values.employee_spouse, "Credit Card" → api_values.credit_card, "ACH" → api_values.ach
@Pipe({
  name: 'translateApiValue',
  pure: false,
  standalone: false,
})
export class TranslateApiValuePipe implements PipeTransform {
  constructor(private i18n: I18nService) {}

  transform(value: string): string {
    return this.i18n.translateApiValue(value);
  }
}
